import { Component } from '@angular/core';
@Component({
  selector: 'cat-page',
  templateUrl: './page-500.html'
})
export class PagesPage500 { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/pages/page-500.page.ts